export enum CardViewEnum {
  COMPACT = 'compact',
  NORMAL = 'normal',
  EXPANDED = 'expanded',
}
